import { render, staticRenderFns } from "./ResetPasswordModal.vue?vue&type=template&id=18690563&scoped=true&"
import script from "./ResetPasswordModal.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18690563",
  null
  
)

export default component.exports